module.exports = __webpack_public_path__ + "static/media/cycle-icon3.ea45d0f3.svg";